/* eslint-disable */
export const GET_CUSTOM_FIELD_START = 'GET_CUSTOM_FIELD_START';
export const GET_CUSTOM_FIELD_SUCCESS = 'GET_CUSTOM_FIELD_SUCCESS';
export const GET_CUSTOM_FIELD_FAIL = 'GET_CUSTOM_FIELD_FAIL';
